import axios from 'axios';

const baseURL = `${(process.env.REACT_APP_API_URL || '').replace(/\/$/, '')}/api`;

export const api = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 120000,
});

export function getErrorMessage(err, fallback = 'Something went wrong. Please try again.') {
  if (!err) return fallback;
  if (err.response && err.response.data) {
    const d = err.response.data;
    if (typeof d === 'string') return d.slice(0, 300) || fallback;
    if (d.error) return d.error;
  }
  if (err.code === 'ECONNABORTED') return 'The request timed out. Please try again.';
  if (err.message === 'Network Error') return 'Cannot reach the server. Check your connection.';
  return err.message || fallback;
}

export function getErrorCode(err) {
  return err && err.response && err.response.data ? err.response.data.code : undefined;
}
